export const getUrlByFileId = (fileId: string): string => {
  return `https://cms.theinquisitor.game/assets/${fileId}`
}
